import React from 'react';
import "./skills.css"
const Prod = () =>{

    return(
        <div className="skills__content">
        <h3 className="skills__title">Production development</h3>
        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>
                <div>
                    <h3 className="skills__name">Linux Scripting</h3>
                    <span className="skills__level">Advanced</span>
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>
                <div>
                    <h3 className="skills__name">Docker</h3>
                    <span className="skills__level">Advanced</span>
                </div>
                </div>


                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>
                <div>
                    <h3 className="skills__name">DevOps</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>
                
            </div>

            <div className="skills__group">
                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>
                <div>
                    <h3 className="skills__name">Cloud Computing</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>
                <div>
                    <h3 className="skills__name">Azure</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check'></i>
                <div>
                    <h3 className="skills__name">MLOps</h3>
                    <span className="skills__level">Advanced</span>
                </div>
                </div>

            </div>

            
        </div>
    </div>
    )
}


export default Prod